// src/utils/mathUtils.js

/**
 * Garante o arredondamento de um número para X casas decimais 
 * mitigando os problemas clássicos de dízimas de ponto flutuante do JavaScript (ex: 0.1 + 0.2).
 * 
 * @param {number|string} num O número a ser arredondado.
 * @param {number} casas O número de casas decimais (padrão: 4).
 * @returns {number} O número final perfeitamente truncado/arredondado.
 */
export const arredondar = (num, casas = 4) => {
    if (num === null || num === undefined || isNaN(num)) return 0;
    
    // O hack do notação exponencial (e) force o JS a mover a casa exatamente pro ponto, arredondar precisamente, e mover de volta.
    return Number(Math.round(parseFloat(num) + `e${casas}`) + `e-${casas}`);
};
